/* eslint-disable react/jsx-key */
"use client";

import React, { useEffect } from "react";
import PortfolioColorscheme from "@/app/components/PortfolioColorscheme/PortfolioColorscheme";
import PortfolioResponsiveDisplays from "@/app/components/PortfolioResponsiveDisplays/PortfolioResponsiveDisplays";
import PortfolioTypography from "@/app/components/PortfolioTypography/PortfolioTypography";
import WebsiteLogo from "@/app/components/WebsiteLogo/websitelogo";
import { WebsiteSubtitle } from "@/app/components/WebsiteSubtitle/WebsiteSubtitle";
import PortfolioTechStack from "@/app/components/PortfolioTechStack/PortfolioTechStack";
import FigmaLogo from "@/app/components/icons/figmaLogo";
import HTML5Logo from "@/app/components/icons/HTML5Logo";
import JSLogo from "@/app/components/icons/JSLogo";
import CSS3Logo from "@/app/components/icons/CSS3Logo";
import NextJSLogo from "@/app/components/icons/nextJsLogo";
import FirebaseLogo from "@/app/components/icons/FirebaseLogo";
import FirstBlockAbout from "@/components/common/FirstBlockAbout";

export default function CleoFaucets() {
  const primaryColor = "#121212";

  useEffect(() => {
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,100..700;1,100..700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <>
      <section className="flex flex-col gap-[100px] my-[35px]">
        <div>
          <WebsiteLogo imageSrc="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FCleo%20Faucets%2Fcleo%20faucets%20logo.webp?alt=media&token=c34b0236-c6ec-4977-be02-20ae180e2db4" />
          <FirstBlockAbout
            media={{
              type: "image",
              src: "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FCleo%20Faucets%2Fcleofaucets%20background.webp?alt=media&token=a6804199-5f47-4e21-b891-91ba6d02534b",
            }}
            primaryColor={primaryColor}
          />
          <WebsiteSubtitle
            text="For Cleo Plumbing, a provider of an extensive selection of high-quality plumbing products, we delivered a comprehensive digital solution to showcase their modern and durable fixtures. We handled the full design and development, building a sophisticated e-commerce platform using Next.js and Firebase for optimal performance and scalability. Our work also included targeted SEO strategies to ensure Cleo Plumbing's stylish offerings appeared prominently to customers seeking quality plumbing solutions."
            title="Deliverables"
            tags={["TYPOGRAPHY", "COLORSCHEME", "RESPONSIVE DESIGN", "TECH STACK"]}
            buttonHref="https://cleofaucet.ca/"
          />
        </div>

        <PortfolioTypography
          typographyData={[
            {
              headline:
                "Excellence in Cleaning Services: delivering unmatched quality and meticulous attention to detail.",
              fontFamily: "Arial",
              fontSize: "36px",
              letterSpacing: "0%",
              lineHeight: "40px",
              textColor: "#2c2d2c",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioColorscheme
          ColorschemeData={[
            {
              title: "Main color",
              color: "#121212",
              rgb: "#121212",
              textColor: "#FFFFFF",
            },
            {
              title: "White",
              color: "#FFFFFF",
              rgb: "#FFFFFF",
              textColor: "#2c2d2c",
            },
            {
              title: "Charcoal Blue",
              color: "#111827",
              rgb: "#111827",
              textColor: "#FFFFFF",
            },
            {
              title: "Platinum Gray",
              color: "#D1D5DB",
              rgb: "#D1D5DB",
              textColor: "#2c2d2c",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioResponsiveDisplays
          ResponsiveDisplaysData={[
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FCleo%20Faucets%2Fcleopc.webp?alt=media&token=bfdac268-013b-4f41-b2e2-84a5ca2e2e41",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FCleo%20Faucets%2Fcleoipad.webp?alt=media&token=9ea146f1-1e5d-40fb-8128-5204ad2d6ea3",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FCleo%20Faucets%2Fcleomobile.webp?alt=media&token=3f177aa0-7dba-4388-9d2e-ab5c21bb2966",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioTechStack
          primaryColor={primaryColor}
          blocks={[
            {
              title: "Design",
              opacity: 5,
              icons: [<FigmaLogo />],
            },
            {
              title: "Layout Development",
              opacity: 15,
              icons: [<HTML5Logo />, <CSS3Logo />, <JSLogo />],
            },
            {
              title: "Server Setup",
              opacity: 25,
              icons: [<FirebaseLogo />],
            },
            {
              title: "Frontend Setup",
              icons: [<NextJSLogo />],
              opacity: 30,
            },
          ]}
        />
      </section>
    </>
  );
}
